"use client";

import clsx from "clsx";

const ExcelThumbnail: React.FC<{
   data: string[][];
   fontSize?: string;
   maxCols?: number;
   maxCellWidth?: string;
}> = ({data, fontSize = "text-[7px]", maxCols = 5, maxCellWidth = "max-w-[50px]"}) => (
   <div className="w-full h-full overflow-hidden p-1.5 pointer-events-none">
      <table className={clsx("w-full leading-tight border-collapse", fontSize)}>
         <tbody>
            {/* Index keys are acceptable here: the data is static and rows have no stable IDs */}
            {data.map((row, r) => (
               <tr key={`row-${r}`}>
                  {(row || []).slice(0, maxCols).map((cell, c) => (
                     <td
                        key={`cell-${r}-${c}`}
                        className={clsx(
                           "border border-300/50 px-0.5 py-px truncate",
                           maxCellWidth,
                           r === 0 && "font-bold bg-200/50"
                        )}
                     >
                        {cell ?? ""}
                     </td>
                  ))}
               </tr>
            ))}
         </tbody>
      </table>
   </div>
);

export default ExcelThumbnail;
